import React from "react";

import { useSelector } from "react-redux";
import { unauthorizedSellersListPrefix } from "../../pages/GdkMiddlewareRequestPage/gdkMiddlewarePageContent";
import { getPartnerCenterSellers } from "../../redux/selectors/partnerCenterSelectors";
import { sellerHasGdkSwRole } from "../../server/partnerCenter/helpers/gdkMiddlewareRequestHelpers";
import * as styles from "./GdkMiddlewareDropdown.module.css";

export const UnauthorizedSellersList = () => {
  const unauthorizedSellers = useSelector(getPartnerCenterSellers).filter(
    seller => !sellerHasGdkSwRole(seller)
  );
  if (!unauthorizedSellers || unauthorizedSellers.length === 0) {
    return null;
  }
  return (
    <span className={styles.unauthorizedSellersList}>
      {unauthorizedSellersListPrefix}
      {unauthorizedSellers.map((seller, index) => (
        <span key={seller.id}>{`${index > 0 ? ", " : ""}${seller.SellerName} (${seller.id})`}</span>
      ))}
    </span>
  );
};
